const formatTestId = (value: string) =>
  value
    .trim()
    .replace(/[\s_,./()]+/g, '-')
    .replace(/^-+|-+$/g, '')

/**
 * Creates a spreadable object with a dash-case `data-test-id`, matching Suite's native
 * (non-hcem-derived) test-id convention rather than `@hconnect/uikit`'s underscore-formatting one.
 */
export const dataTestId = (value: string | number): {'data-test-id': string} => ({
  'data-test-id': formatTestId(`${value}`)
})
